var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8NodeJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f1edd5",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#21a366",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.007,45.419c-0.574,0 -1.143,-0.15 -1.646,-0.44l-5.24,-3.103c-0.783,-0.438 -0.401,-0.593 -0.143,-0.682c1.044,-0.365 1.255,-0.448 2.369,-1.081c0.117,-0.067 0.27,-0.043 0.39,0.028l4.026,2.389c0.145,0.079 0.352,0.079 0.486,0l15.697,-9.061c0.145,-0.083 0.24,-0.251 0.24,-0.424v-18.113c0,-0.181 -0.094,-0.342 -0.243,-0.432l-15.69,-9.054c-0.145,-0.086 -0.338,-0.086 -0.483,0l-15.688,9.053c-0.152,0.086 -0.249,0.255 -0.249,0.428v18.114c0,0.173 0.094,0.338 0.244,0.42l4.299,2.483c2.334,1.167 3.76,-0.208 3.76,-1.591v-17.877c0,-0.255 0.2,-0.452 0.456,-0.452h1.988c0.248,0 0.452,0.196 0.452,0.452v17.886c0,3.112 -1.697,4.9 -4.648,4.9c-0.908,0 -1.623,0 -3.619,-0.982l-4.118,-2.373c-1.018,-0.59 -1.647,-1.691 -1.647,-2.865v-18.114c0,-1.179 0.629,-2.279 1.646,-2.861l15.714,-9.065c0.994,-0.562 2.314,-0.562 3.301,0l15.694,9.069c1.012,0.585 1.645,1.682 1.645,2.861v18.114c0,1.175 -0.633,2.271 -1.646,2.861l-15.694,9.064c-0.503,0.291 -1.073,0.44 -1.654,0.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.856,32.937c-6.868,0 -8.308,-3.153 -8.308,-5.797c0,-0.251 0.203,-0.452 0.455,-0.452h2.028c0.224,0 0.413,0.163 0.448,0.384c0.306,2.066 1.218,3.108 5.371,3.108c3.308,0 4.715,-0.747 4.715,-2.502c0,-1.01 -0.401,-1.76 -5.54,-2.263c-4.299,-0.424 -6.955,-1.371 -6.955,-4.809c0,-3.167 2.672,-5.053 7.147,-5.053c5.026,0 7.517,1.745 7.831,5.493c0.012,0.13 -0.035,0.255 -0.122,0.35c-0.086,0.09 -0.208,0.145 -0.334,0.145h-2.039c-0.212,0 -0.397,-0.149 -0.44,-0.354c-0.491,-2.173 -1.678,-2.868 -4.904,-2.868c-3.611,0 -4.031,1.257 -4.031,2.2c0,1.143 0.495,1.477 5.367,2.122c4.825,0.64 7.116,1.544 7.116,4.935c0,3.418 -2.853,5.379 -7.827,5.379"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NodeJs);
export default __webpack_public_path__ + "static/media/icons8-node-js.64e9db28fa32fdb3986587692328c390.svg";
export { ForwardRef as ReactComponent };